module.exports = __webpack_public_path__ + "static/media/DGB.080c889d.svg";